import { SharedAngular } from '@Client/@types/sharedAngular';
import angular from 'angular';

angular.module('flowingly.runner.library').config(config);
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state('app.runner.library.drafts', {
    url: '/drafts',
    params: { title: 'Library -  Drafts' },
    views: {
      childcontent: {
        controllerAs: '$ctrl',
        controller: [
          'flowModelApiService',
          function (flowModelApiService: SharedAngular.FlowModelApiService) {
            this.service = flowModelApiService;
          }
        ],
        template:
          '<flow-library-tabs-drafts flow-models="$ctrl.service.flowModels" flow-model-tags="$ctrl.service.flowModelTags"></flow-library-tabs-drafts>'
      }
    }
  });
}
